import { makeStyles, createStyles } from "@material-ui/core";
import colors from "../../common/styles/colors";

/**
 * Folha da Home.
 *
 * Os cards da Home são `sx` v5 lendo `palette` (ver `HomeActionCard`); aqui
 * fica apenas o título da página, que ainda é JSS v4 e lê `colors`.
 */
export const useHomeStyles = makeStyles(() =>
  createStyles({
    /** Título da página — "Seja bem vindo (a), <nome>". */
    message: {
      color: colors.purpleDarkest,
    },
  })
);
